import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {
  package as PackagePropType,
  teaseStyles as TeaseStylesPropType,
} from 'lib/CustomPropTypes';

import LeadBorderTop from 'components/LeadBorderTop';
import PackageTitle from 'components/PackageTitle';
import SlideshowTeasePicture from 'components/SlideshowTeasePicture';
import TeaseCard from 'components/TeaseCard';
import TeasePicture from 'components/TeasePicture';
import AIMS_FLAVORS from 'lib/aimsFlavors';

import teaseStyles from './teaseStyles.module.scss';

function getPicture(item) {
  if (item.type === 'slideshow') {
    return (
      <SlideshowTeasePicture
        slides={item.slides || item.item.slides}
        sizes={{
          s: 360, m: 460, l: 260, xl: 380,
        }}
        rectangle
      />
    );
  }
  return (
    <TeasePicture
      responsiveFlavors={{
        s: AIMS_FLAVORS.FOCAL_758x379,
        m: AIMS_FLAVORS.FOCAL_1000x500,
        l: AIMS_FLAVORS.FOCAL_1240x620,
        xl: AIMS_FLAVORS.FOCAL_1240x620,
      }}
      type={item.type}
      computedValues={item.computedValues}
    />
  );
}

function OneUp(props) {
  const {
    content,
    standalone,
    isRailAdjacent,
    pkgClassName,
    propStyles,
    vertical,
    isFirstLayout,
    isMobileOnlyComponent,
    alternateTitleFormat,
  } = props;

  if (!content || !(content.items && content.items[0])) return null;
  const {
    id, items, metadata = {}, packageIndex,
  } = content;

  const item = items[0];
  const shouldSendPkgClassName = standalone || pkgClassName === 'pkg leadSectionFront' ? pkgClassName : null;
  const isFirstLayoutAndPackage = isFirstLayout && !packageIndex;

  return (
    <section
      className={classNames(
        pkgClassName,
        `pkg-index-${packageIndex + 1}`,
        {
          [teaseStyles.standalone]: standalone,
          'one-up--show-accent-line': isFirstLayoutAndPackage,
        },
      )}
      data-packageid={id}
      data-test="one-up__section"
    >
      <LeadBorderTop types={['collectionLead']} />
      {metadata && metadata.title && (
        <PackageTitle
          metadata={metadata}
          alternateDisplayFormat={alternateTitleFormat}
        />
      )}
      <TeaseCard
        isMobileOnlyComponent={isMobileOnlyComponent}
        content={item}
        isRailAdjacent={isRailAdjacent}
        pkgClassName={shouldSendPkgClassName}
        styles={{ ...teaseStyles, ...propStyles }}
        vertical={vertical}
        {...metadata}
        {...item.metadata}
      >
        {getPicture(item)}
      </TeaseCard>
    </section>
  );
}

OneUp.propTypes = {
  content: PackagePropType.isRequired,
  isRailAdjacent: PropTypes.bool,
  pkgClassName: PropTypes.string,
  propStyles: TeaseStylesPropType,
  standalone: PropTypes.bool,
  vertical: PropTypes.string,
  isFirstLayout: PropTypes.bool,
  alternateTitleFormat: PropTypes.bool,
  isMobileOnlyComponent: PropTypes.bool,
};

OneUp.defaultProps = {
  isRailAdjacent: false,
  standalone: false,
  pkgClassName: 'pkg one-up',
  propStyles: {},
  vertical: '',
  isFirstLayout: false,
  alternateTitleFormat: false,
  isMobileOnlyComponent: false,
};

export default OneUp;
